<div class="recently-visited-list ticker-list" [style.maxHeight]="maxHeight">
  <div class="company" *ngFor="let data of dataToUse">
    <va-icon
      size="small"
      [name]="data.isSelected ? 'check' : 'plus'"
      [class]="data.isSelected ? 'added-comp' : 'add-comp'"
      (click)="addTicker(data)"
    ></va-icon
    ><ng-container *ngIf="company">{{ data[company] }}: </ng-container
    >{{ data[field]
    }}<ng-container *ngIf="data.line_count"
      >&nbsp;({{ data.line_count }})</ng-container
    >
  </div>
</div>
